export interface AuctionIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const AuctionIcon = ({ size = 24, ...props }: AuctionIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      viewBox='0 0 24 24'
      width={size}
      height={size}
      {...props}
    >
      <path d='M8.41612 4.57442L13.5184 7.529C13.9215 7.76199 14.4358 7.62355 14.6673 7.22004C14.9004 6.81653 14.7624 6.29989 14.3601 6.06775L9.2578 3.11317C8.85463 2.88018 8.34037 3.01862 8.10806 3.42129C7.87576 3.82395 8.0138 4.34058 8.41612 4.57442ZM13.0984 8.26005L7.99612 5.30547L5.05024 10.4228L10.1525 13.3774L13.0984 8.26005ZM3.78688 12.6159L8.88914 15.5705C9.29146 15.8035 9.80657 15.6651 10.038 15.2616C10.2695 14.8581 10.1323 14.3414 9.73082 14.1093L4.62856 11.1547C4.2254 10.9217 3.71113 11.0602 3.47883 11.4628C3.24568 11.8663 3.38456 12.383 3.78688 12.6159ZM21.3687 14.9982L12.0463 10.0877L11.2046 11.5498L20.1062 17.1913C20.7097 17.5408 21.4823 17.334 21.8308 16.7279C22.1793 16.1218 21.9722 15.3477 21.3687 14.9982ZM12.1279 19.2604C12.1279 18.7936 11.7508 18.4162 11.2862 18.4162H3.71113C3.24568 18.4162 2.86945 18.7936 2.86945 19.2604C2.86945 19.7264 2.86945 20.1046 2.86945 20.1046L2 20.0868L2.02778 20.9487H12.9696L13.0092 20.14L12.1809 20.1046C12.1809 20.1046 12.1279 19.7264 12.1279 19.2604Z' />
    </svg>
  );
};
export default AuctionIcon;
